import HomeIcon from '../../icons/home.svg';
import ActivityCenterIcon from '../../icons/activity center.svg';
import ProductsIcon from '../../icons/products.svg';
import BookOpenIcon from '../../icons/BookOpen.svg';
import { checkPermission, getNavLinkPermission } from "../Helpers/CheckAccess";
import { getSessionStorageItem, ADVISOR_OBJECT_KEY } from '../../sessionStorage';
import { ActivityCenterPath, ProductPath, ResourceCenterPath } from '../Common/Products/ProductsRoute';

var advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
var role = advisorObj && advisorObj.role;

const layOutNavLink = (accountObj) => [
  {
    text: 'Home',
    link: '/',
    icon: HomeIcon,
    isActive: false,
    isHide: getNavLinkPermission(role, "Home")
  },
  {
    text: 'Activity Center',
    link: ActivityCenterPath,
    icon: ActivityCenterIcon,
    isActive: false,
    isHide: getNavLinkPermission(role, "Activity Center")
  },
  {
    text: 'Products',
    link: ProductPath,
    icon: ProductsIcon,
    isActive: false,
    isHide: getNavLinkPermission(role, "Products")
  },
  {
    text: 'Resource Center',
    link: ResourceCenterPath,
    icon: BookOpenIcon,
    isActive: false,
    isHide: !(checkPermission('enableResourceCenter', accountObj)),
  }
];

const setDefaultLinks = (account) => {
  let navLinksList = layOutNavLink(account);

  let links = navLinksList.filter((links) => !links.isHide);
  links.forEach((part, index, array) => { array[index].isActive = false; });

  let currentURL = window.location.href.split('/');

  currentURL = currentURL.map((url) => url.split("?")[0]);

  currentURL.forEach((linkSegment, i) => {
    let activeNavItem = links.find(item => item.link.replace('/', '') === linkSegment);

    if (activeNavItem) {
      activeNavItem.isActive = true;
    }
  });

  let activeItems = links.filter(item => item.isActive === true);

  if (activeItems.length > 1) {
    links = links.map(item => item.text === 'Home' ? { ...item, isActive: false } : item);
  }

  return links;
}

export { setDefaultLinks }



// WEBPACK FOOTER //
// ./src/components/Layout/LayoutConst.js